export default __webpack_public_path__ + "static/media/github.a9a4ed2e.svg";